import { Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

export interface TextGroupProps {
  heading: string;
  description: string;
}

export const TextGroup: FC<TextGroupProps> = ({ heading, description }) => (
  <Stack space="xxsmall">
    <Text size="small" weight="strong">
      {heading}
    </Text>
    <Text size="small" tone="secondary">
      {description}
    </Text>
  </Stack>
);
